export const ROLE_NNG = "nngStandardRole";
export const RESOURCE_ACCESS_NNG = "nng";
export const OPERATOR = "Operator";
export const RESOURCE_ACCESS_PORTALE_GA = "portale-ga";
export const REPRESENTATIVE_USER = "REPRESENTATIVE_USER";
